import { Component } from '@angular/core';

@Component({
  selector: 'contract-landing',
  templateUrl: './contract-landing.component.html'
})
export class ContractLandingComponent {}
